module.exports = __webpack_public_path__ + "static/media/guidelineGrid.c6683f2e.png";